import { Observable, tap } from 'rxjs';

import { HttpEvent, HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';

import { PendoService } from '@cxc/core/services';

export interface PendoEventTracking {
  name: string;
  log: { next?: boolean; complete?: boolean; error?: boolean };
  data?: any;
}

export function httpTrackEventInterceptor(
  req: HttpRequest<unknown>,
  next: HttpHandlerFn
): Observable<HttpEvent<unknown>> {
  const pendoService = inject(PendoService);

  if (!req.headers.has('Track-Opt-In')) {
    return next(req);
  }

  if (req.headers.get('Track-Opt-In') === 'undefined') {
    req = req.clone({
      headers: req.headers.delete('Track-Opt-In'),
    });
    return next(req);
  }

  const key: PendoEventTracking = JSON.parse(req.headers.get('Track-Opt-In')!);

  req = req.clone({
    headers: req.headers.delete('Track-Opt-In'),
  });

  // Send events to Pendo
  const sendEvent = (requestState: string) => {
    pendoService.trackEvent(
      `${requestState}-${pendoService.analyticsLabelify(key.name)}`,
      {
        ...key.data,
        requestState: requestState,
      },
      false
    );
  };

  return next(req).pipe(
    tap({
      next: () => {
        if (key.log.next) {
          sendEvent('NEXT');
        }
      },
      complete: () => {
        if (key.log.complete) {
          sendEvent('COMPLETED');
        }
      },
      error: () => {
        if (key.log.error) {
          sendEvent('ERROR');
        }
      },
    })
  );
}
